import { createSelector } from "reselect";

const selectHuntStatusState = state => state.manageHunt.huntStatus;

export const selectStatusLoading = createSelector(
  [selectHuntStatusState],
  footerState => footerState.get("stateLoading")
);
